export const apiEndpoint: string = process.env.REACT_APP_API_BASE_URL as string;